export const flattenNestedArrays = (reportRes, stepOneDefault, stepThreeDefault, stepFourDefault) => {
  const flattenArray = (arr, defaultValue) => {
    if (!arr || !Array.isArray(arr)) {
      return defaultValue;
    }

    const flatten = (item) => {
      if (!Array.isArray(item)) {
        return item;
      }
      if (item.length === 0) {
        return null;
      }
      if (Array.isArray(item[0])) {
        return flatten(item[0]);
      }
      if (typeof item[0] === 'string') {
        return item;
      }
      return item;
    };

    const result = flatten(arr);
    return result && Array.isArray(result) && result.length > 0 ? result : defaultValue;
  };

  reportRes.stepOneTogg = flattenArray(reportRes.stepOneTogg, stepOneDefault);
  reportRes.stepThreeTogg = flattenArray(reportRes.stepThreeTogg, stepThreeDefault);
  reportRes.stepFourTogg = flattenArray(reportRes.stepFourTogg, stepFourDefault);

  if (reportRes.open) {
    reportRes.open = flattenArray(reportRes.open, []);
  }

  const protectedFields = [
    'stepOneTogg', 
    'stepThreeTogg', 
    'stepFourTogg',
    'open',
    'attachments',
    'Allimagedescription',
    'footerLogo',
    'selectededlogos',
    'gc_lotnumber',
    'gc_subdivision'
  ];

  Object.keys(reportRes).forEach(key => {
    const value = reportRes[key];

    if (protectedFields.includes(key)) {
      return;
    }

    if (Array.isArray(value)) {
      if (value.length > 0 && Array.isArray(value[0])) {
        const firstNestedItem = value[0][0];
        const isSimpleValue = typeof firstNestedItem === 'string' || 
                             typeof firstNestedItem === 'number' || 
                             firstNestedItem === null || 
                             firstNestedItem === undefined;

        if (!isSimpleValue) {
          return;
        }

        const flattened = flattenArray(value, []);

        if (flattened && flattened.length > 0) {
          reportRes[key] = flattened;
        } else {
          reportRes[key] = [];
        }
      }
    }
  });

  return reportRes;
};